/**
 * Opciones de depósito para autocompletar: nombre y, en la segunda línea, el código.
 * @param {Array<Object>} warehouses Depósitos.
 * @returns {Array<{value: string, label: string, secondary: string}>}
 */
export const toWarehouseOptions = (warehouses = []) =>
  warehouses.map((warehouse) => ({
    value: warehouse.uuid,
    label: warehouse.name || warehouse.code || '',
    secondary: warehouse.name ? warehouse.code || '' : '',
  }));
